import { render, staticRenderFns } from "./IABFDancers.vue?vue&type=template&id=d923ca3c"
import script from "./IABFDancers.vue?vue&type=script&lang=js"
export * from "./IABFDancers.vue?vue&type=script&lang=js"
import style0 from "./IABFDancers.vue?vue&type=style&index=0&id=d923ca3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports